import { render } from "./InteractionsContent.vue?vue&type=template&id=330385aa"
import script from "./InteractionsContent.vue?vue&type=script&lang=js"
export * from "./InteractionsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__